import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { Icon, SecondaryTextXs, BorderlessKeyInput, FilterCounter } from 'atoms';
import { RelativeWrapper, FullWidthFlexCenterWrapper, WhiteSpaceNoWrap, Mx2, FullWidthRowCenterScrollWrapper, Width200 } from 'wrappers';
import Controller from './controller';
import { DropdownOptionRow } from './molecules';
import { DropdownTextButton } from 'molecules';
import { BodyWrapper, HeaderWrapper } from './wrappers';
import internalState from './internalState';
import { DownCaretSvg } from 'components/icons';
import labelSwitch from './labelSwitch';
import { escapedRegex } from 'utils';

const containerRef = React.createRef()
const inputRef = React.createRef()
const headerRef = React.createRef();

export const definition = {
  name: 'Dropdown',
  controller: Controller,
  initialProps: ({ options, selectedOptionIds, label, multipleSelect, hasSearch, placeholder, openOnTop, scrollLeft }) => ({
    options, selectedOptionIds,
    label, multipleSelect, hasSearch,
    placeholder, openOnTop,
    left: scrollLeft ? ((headerRef?.current?.offsetLeft ?? 0) - scrollLeft) : 0
  }),
  props: internalState,
  elements: [
    {
      wrapper: HeaderWrapper,
      name: 'Selector',
      ref: headerRef,
      isButton: true,
      bindings: ({ isOpen, multipleSelect, selectedOptionIds, options }) => ({ isOpen, containerRef, multipleSelect, selectedOptionIds, options, inputRef }),
      elements: [
        {
          wrapper: FullWidthFlexCenterWrapper,
          name: 'LeftSide',
          elements: [
            {
              componentSelect: labelSwitch,
              name: 'Label',
              displayValue: ({ label }) => label.values[0],
              renderIf: ({ label }) => !!label?.component,
              bindings: ({ label }) => {
                if (label.keys?.length > 0) {
                  const combinedValues = { ...label };
                  label.keys.forEach((key, index) => {
                    combinedValues[key] = label.values[index];
                  });
                  return combinedValues;
                }
                return label;
              }
            },
            {
              wrapper: wrap(FullWidthRowCenterScrollWrapper, Width200),
              name: 'Wrapper',
              ref: ({ inputRef }) => inputRef ?? null,
              elements: [
                {
                  component: DropdownTextButton,
                  name: 'SelectedButton',
                  renderIf: ({ multipleSelect }) => multipleSelect,
                  isListOf: 'selectedOptionIds',
                  bindings: ({ selectedOptionId, selectedOptionIds, options }) => {
                    return { text: options.find(o => o.id === selectedOptionId)?.name ?? '', selectedOptionId, selectedOptionIds }
                  }
                },
                {
                  component: wrap(wrap(SecondaryTextXs, WhiteSpaceNoWrap), Mx2),
                  name: 'SelectedValue',
                  renderIf: ({ multipleSelect, selectedOptionIds, isOpen }) => !isOpen && !multipleSelect && selectedOptionIds.length > 0,
                  displayValue: ({ options, selectedOptionIds }) => {
                    let option = options.find(o => o.id === selectedOptionIds[0]);
                    return option?.display ?? '';
                  }
                },
                {
                  component: BorderlessKeyInput,
                  name: 'SearchInput',
                  renderIf: ({ hasSearch }) => hasSearch,
                  bindings: ({ searchTerm, placeholder, isOpen, selectedOptionIds }) => ({ value: searchTerm, placeholder: (isOpen || selectedOptionIds.length === 0) ? (placeholder ?? "Search...") : '' })
                }
              ]
            },
          ]
        },
        {
          component: wrap(FilterCounter, Mx2),
          name: 'Counter',
          displayValue: ({ selectedOptionIds }) => selectedOptionIds?.length ?? 0
        },
        {
          component: Icon,
          name: 'DownCaretSvg',
          displayValue: () => DownCaretSvg({}),
          bindings: () => ({})
        }
      ]
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      ref: () => containerRef ?? null,
      displayState: ({ openOnTop, left }) => ({ width: headerRef?.current?.offsetWidth, openOnTop, left }),
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: DropdownOptionRow,
          name: 'Option',
          isListOf: 'options',
          renderIf: ({ option, searchTerm }) => escapedRegex(searchTerm).test(option.name) || escapedRegex(searchTerm).test(option.unit),
          bindings: ({ option, selectedOptionIds, multipleSelect }) => ({ option, selectedOptionIds, multipleSelect }),
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), RelativeWrapper);
